var map = {
	"./Background.png": "./src/assets/images/Background.png",
	"./CAS-Background.jpg": "./src/assets/images/CAS-Background.jpg",
	"./CAS-Background.png": "./src/assets/images/CAS-Background.png",
	"./CAS_Logo.png": "./src/assets/images/CAS_Logo.png",
	"./app_logo.png": "./src/assets/images/app_logo.png",
	"./english.png": "./src/assets/images/english.png",
	"./japanese.png": "./src/assets/images/japanese.png",
	"./n00121.jpg": "./src/assets/images/n00121.jpg",
	"./n00122.jpg": "./src/assets/images/n00122.jpg",
	"./n00123.jpg": "./src/assets/images/n00123.jpg",
	"./n00124.jpg": "./src/assets/images/n00124.jpg",
	"./n00125.jpg": "./src/assets/images/n00125.jpg",
	"./rapidtest_dashboard_logo.png": "./src/assets/images/rapidtest_dashboard_logo.png",
	"./rapidtest_logo.png": "./src/assets/images/rapidtest_logo.png",
	"./sprite.png": "./src/assets/images/sprite.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";